<div class="page institutional-relations">
    <div class="title">
        Organismos y entidades subvencionantes        
    </div>
    <div>
        <div class="illustrated-item" id="entrada4">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Fundación Ibercaja</p>
                <p>Entidad subvencionante: Convocatorias de Proyectos Sociales</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada11">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Ministerio de Sanidad, Consumo y Bienestar Social</p>
                <p>Organismo subvencionante: Subvenciones con cargo a la asignación tributaria del 0,7 % del IRPF. Concesión directa con cargo al IS.</p>
            </div>
        </div>
    </div>
    <div class="title">
        Organismos y entidades colaboradoras        
    </div>
    <div>
        <div class="illustrated-item" id="entrada3">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Cruz Roja</p>
                <p>Donación de productos de primera necesidad.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada6">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Banco de alimentos</p>
                <p>Provisión de alimentos con caracter gratuíto.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada12">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Fundación Integra</p>
                <p>Impartición de cursos de formación para el empleo y colocación.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada13">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Asociación Eslabón</p>
                <p>Impartición de cursos de formación para el empleo y colocación.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada14">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Centro de Atención a las Adicciones de Vallecas (CAD III)</p>
                <p>Atención personalizada en régimen ambulatorio a personas con problemas de adicciones.</p>
            </div>
        </div>
    </div>
    <div class="title">
        Otras relaciones institucionales        
    </div>
    <div>
        <div class="illustrated-item" id="entrada5">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">IVIMA</p>
                <p>Cesión de los inmuebles en régimen de alquiler.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada7">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">S. G. de Instituciones Penitenciarias</p>
                <p>Interacción para actuaciones en los centros penitenciarios.</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada8">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Universidad Complutense de Madrid</p>
                <p>Prácticas Grado en Educación Social y Grado en Pedagogía</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada9">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Universidad Rey Juan Carlos</p>
                <p>Prácticas Grado en Criminología</p>
            </div>
        </div>
        <div class="illustrated-item" id="entrada10">
            <div class="illustration"></div>
            <div class="content">
                <p class="title">Universidad Pontificia de Comillas</p>
                <p>Prácticas Doble Grado en Psicología y Criminología</p>
            </div>
        </div>
    </div>
</div>